import React from "react"

function Recycle({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.4818 10.8864C20.5607 10.5053 19.5507 10.2949 18.4914 10.2949C16.5571 10.2949 14.787 10.9964 13.4226 12.1583C12.9975 12.5203 12.6117 12.9271 12.2727 13.3712M10.6789 18.0907C10.6789 20.2434 11.5534 22.1923 12.9671 23.6031C13.6868 24.3212 14.5461 24.8998 15.501 25.2949M21.4818 25.2949C22.4367 24.8998 23.2961 24.3212 24.0157 23.6031C25.4295 22.1923 26.3039 20.2434 26.3039 18.0907C26.3039 17.0337 26.0931 16.0258 25.7111 15.1067"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3899 12.8943L20.5 12.7718L22.554 8.90895L25.3899 12.8943Z"
        fill="#003E4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5661 25.8612L22.2259 22.6159L23.3582 26.8418L18.5661 25.8612Z"
        fill="#003E4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6791 14.6699L12.8666 19.0449H8.49155L10.6791 14.6699Z"
        fill="#003E4C"
      />
    </svg>
  )
}
export default Recycle
